import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";
import {
  IPayoutResponse,
  PayoutStatusEnum
} from "../../../services/api/payments/payouts/types";

export const getFailedStatusCount = (payout: IPayoutResponse) => {
  const allTransfers: paymentsApiSpec.PayoutTransfer[] =
    payout?.bankingFundsTransfer
      ? [
          payout?.bankingFundsTransfer,
          ...(payout?.externalFundsTransfers || [])
        ]
      : (payout?.externalFundsTransfers || []).filter(
          transfer => transfer?.fundsMovementId !== undefined
        );

  const allErrorTransfers = allTransfers.filter(
    transfer => transfer.status === PayoutStatusEnum.Failed
  );

  return {
    errorsLength: allErrorTransfers.length,
    transfersLength: allTransfers.length
  };
};
